import { clearStore } from "../actions/StoreAction";

export default {
	validateToken: (token) => {
        const base64Payload = token.split('.')[1];
        const payload = Buffer.from(base64Payload, 'base64');
        const decodeToken = JSON.parse(payload.toString());
        const { exp } = decodeToken;
        const currentUnix = Math.round(+new Date() / 1000);
        if (currentUnix > exp) return false;
        else return true;
	}
};


// WEBPACK FOOTER //
// ./src/util/token.js